import { Code, DataObject, History } from "@mui/icons-material";
import { IconButton, Menu, MenuItem, ListItemIcon, ListItemText } from "@mui/material";
import React, { useState } from "react";

type DevToolsMenuProps = {
  onPreview: () => void;
  isPreviewLoading: boolean;
  onRawHistory: () => void;
  hasHistory: boolean;
};

const DevToolsMenu = ({
  onPreview,
  isPreviewLoading,
  onRawHistory,
  hasHistory,
}: DevToolsMenuProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  return (
    <>
      <IconButton
        size="small"
        onClick={(e) => setAnchorEl(e.currentTarget)}
        title="Developer Tools"
        sx={{ color: "text.secondary" }}
      >
        <Code fontSize="small" />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MenuItem
          onClick={() => {
            setAnchorEl(null);
            onPreview();
          }}
          disabled={isPreviewLoading}
        >
          <ListItemIcon>
            <DataObject fontSize="small" />
          </ListItemIcon>
          <ListItemText>{isPreviewLoading ? "Preparing..." : "Document Preview"}</ListItemText>
        </MenuItem>
        <MenuItem
          onClick={() => {
            setAnchorEl(null);
            onRawHistory();
          }}
          disabled={!hasHistory}
        >
          <ListItemIcon>
            <History fontSize="small" />
          </ListItemIcon>
          <ListItemText>Raw History</ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
};

export default DevToolsMenu;
